import { render } from "./UploadBox.vue?vue&type=template&id=6c73048e&scoped=true"
import script from "./UploadBox.vue?vue&type=script&lang=js"
export * from "./UploadBox.vue?vue&type=script&lang=js"

import "./UploadBox.vue?vue&type=style&index=0&id=6c73048e&lang=less"
import "./UploadBox.vue?vue&type=style&index=1&id=6c73048e&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.1_@vue+compiler-sfc@3.3.11_vue@3.3.11_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c73048e"]])

export default __exports__